const all = ['stellair']
const login = [...all, 'login']

export const stellairKeys = {
  all,
  login,
}
